export const config = {
    OPENAI_API_KEY: process.env.REACT_APP_OPENAI_API_KEY,
    WEATHER_API_KEY: process.env.REACT_APP_WEATHER_API_KEY,
    WEATHER_API_BASE_URL: 'https://api.weatherapi.com/v1',
};
